var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Event_1;
import { xsd } from 'lincd-xsd/ontologies/xsd';
import { XSDDate } from 'lincd-xsd/shapes/XSDDate';
import { ShapeSet } from 'lincd/collections/ShapeSet';
import { literalProperty, objectProperty } from 'lincd/shapes/SHACL';
import { schema } from '../ontologies/schema.js';
import { linkedShape } from '../package.js';
import { ImageObject } from './ImageObject.js';
import { Person } from './Person.js';
import { Place } from './Place.js';
import { Thing } from './Thing.js';
let Event = Event_1 = class Event extends Thing {
    get startDate() {
        return this.hasProperty(schema.startDate)
            ? XSDDate.toNativeDate(this.getOne(schema.startDate))
            : null;
    }
    set startDate(nativeDate) {
        this.overwrite(schema.startDate, XSDDate.fromNativeDate(nativeDate).node);
    }
    get endDate() {
        return this.hasProperty(schema.endDate)
            ? XSDDate.toNativeDate(this.getOne(schema.endDate))
            : null;
    }
    set endDate(nativeDate) {
        this.overwrite(schema.endDate, XSDDate.fromNativeDate(nativeDate).node);
    }
    get attendees() {
        return Person.getSetOf(this.getAll(schema.attendee));
    }
    get location() {
        return this.getOneAs(schema.location, Place);
    }
    set location(val) {
        this.overwrite(schema.location, val ? val.node : null);
    }
    get image() {
        return this.getOneAs(schema.image, ImageObject);
    }
    set image(val) {
        this.overwrite(schema.image, val.node);
    }
    get superEvent() {
        return this.getOneAs(schema.superEvent, Event_1);
    }
    set superEvent(val) {
        this.overwrite(schema.superEvent, val.node);
    }
};
Event.targetClass = schema.Event;
__decorate([
    literalProperty({
        path: schema.startDate,
        maxCount: 1,
        datatype: xsd.dateTime,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Event.prototype, "startDate", null);
__decorate([
    literalProperty({
        path: schema.endDate,
        maxCount: 1,
        datatype: xsd.dateTime,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Event.prototype, "endDate", null);
__decorate([
    objectProperty({
        path: schema.attendee,
        shape: Person,
    }),
    __metadata("design:type", ShapeSet),
    __metadata("design:paramtypes", [])
], Event.prototype, "attendees", null);
__decorate([
    objectProperty({
        path: schema.location,
        shape: Place,
        maxCount: 1,
    }),
    __metadata("design:type", Place),
    __metadata("design:paramtypes", [Place])
], Event.prototype, "location", null);
__decorate([
    objectProperty({
        path: schema.image,
        shape: ImageObject,
        maxCount: 1,
    }),
    __metadata("design:type", ImageObject),
    __metadata("design:paramtypes", [ImageObject])
], Event.prototype, "image", null);
Event = Event_1 = __decorate([
    linkedShape({
        description: 'An occurrence happening at a certain time and location. Represents events with start/end dates, attendees, and location. (occurrence, happening, gathering)',
    })
], Event);
export { Event };
//# sourceMappingURL=Event.js.map